type FilterValue = string | object | null;

export const hasEnabledFilter = (...filters: FilterValue[]): boolean =>
  filters.some((filter) => {
    if (typeof filter === 'string') return filter.trim() !== '';
    if (filter === null) return false;
    return Object.values(filter).some(Boolean);
  });
